import { c as create_ssr_component, o as onDestroy, b as add_attribute } from "./ssr.js";
import { f as fromHTML } from "./prosemirrorUtil.js";
import { b as buildKeymap, p as placeholderPlugin, m as multiLinePlainTextSchema, s as singleLinePlainTextSchema } from "./prosemirrorPlugins.js";
import { a as activeEditorView } from "./stores2.js";
import { Plugin, EditorState } from "prosemirror-state";
import { history } from "prosemirror-history";
import { keymap } from "prosemirror-keymap";
import { baseKeymap } from "prosemirror-commands";
const css = {
  code: "#prosemirror-editor .ProseMirror{outline:none;white-space:pre-wrap;word-wrap:break-word}",
  map: null
};
const PlainTextEditor = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let schema;
  let { content = "" } = $$props;
  let { multiLine = false } = $$props;
  let { placeholder = "Enter text" } = $$props;
  let prosemirrorNode;
  const onUpdatePlugin = new Plugin({
    view() {
      return {
        update(updatedView) {
          activeEditorView.set(updatedView);
        }
      };
    }
  });
  onDestroy(() => {
  });
  if ($$props.content === void 0 && $$bindings.content && content !== void 0)
    $$bindings.content(content);
  if ($$props.multiLine === void 0 && $$bindings.multiLine && multiLine !== void 0)
    $$bindings.multiLine(multiLine);
  if ($$props.placeholder === void 0 && $$bindings.placeholder && placeholder !== void 0)
    $$bindings.placeholder(placeholder);
  $$result.css.add(css);
  schema = multiLine ? multiLinePlainTextSchema : singleLinePlainTextSchema;
  {
    {
      const doc = fromHTML(schema, content);
      EditorState.create({
        doc,
        schema,
        plugins: [
          keymap(buildKeymap(schema)),
          keymap(baseKeymap),
          history(),
          onUpdatePlugin,
          placeholderPlugin(placeholder)
        ]
      });
    }
  }
  return `<div id="prosemirror-editor"${add_attribute("this", prosemirrorNode, 0)}></div>`;
});
export {
  PlainTextEditor as default
};
